"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferDetailsSkillTag = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const types_1 = require("@src/types");
const antd_1 = require("antd");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const styled_components_1 = __importStar(require("styled-components"));
const OfferDetails_style_1 = require("./OfferDetails.style");
const StyledTable = styled_components_1.default.table `
	width: 100%;
	max-width: 300px;
	padding: 0 1rem;
`;
const SkillLevelWrapper = styled_components_1.default.div `
	width: 100%;
`;
const SkillLevelText = styled_components_1.default.div `
	color: ${({ theme }) => theme.color.brand1};
	font-weight: bold;
	position: relative;
	width: fit-content;
	left: ${({ widthMultiplier }) => (widthMultiplier !== 1 ? 20 * widthMultiplier : 0)}%;
	transform: translateX(
		-${({ widthMultiplier }) => {
    if (widthMultiplier === 1) {
        return 0;
    }
    if (widthMultiplier === 5) {
        return 100;
    }
    return 50;
}}%
	);
`;
function mapRatesOnTagNames(skillTags, skillTagsRates) {
    const tagsWithRates = skillTags.map(tag => {
        const matchedRate = skillTagsRates.find(tagRate => tagRate.id === tag.id);
        return {
            id: tag.id,
            name: tag.name,
            value: matchedRate.value,
        };
    });
    return tagsWithRates;
}
const OfferDetailsSkillTag = ({ skillTags, skillTagsRates, areSkillsRated }) => {
    const theme = (0, styled_components_1.useTheme)();
    const areTagsRated = areSkillsRated && skillTagsRates && skillTagsRates.every(skillTagRate => skillTagRate.value);
    const tags = skillTagsRates && skillTagsRates.length ? mapRatesOnTagNames(skillTags, skillTagsRates) : skillTags;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [areTagsRated && ((0, jsx_runtime_1.jsx)(StyledTable, { children: (0, jsx_runtime_1.jsx)("tbody", { children: tags.map(tag => ((0, jsx_runtime_1.jsx)("tr", { className: "m-b-m", children: (0, jsx_runtime_1.jsxs)("td", { children: [tag.name, (0, jsx_runtime_1.jsx)(antd_1.Progress, { showInfo: false, type: "line", percent: (100 / 5) * tag.value, strokeColor: theme.color.brand1 }), (0, jsx_runtime_1.jsx)(SkillLevelWrapper, { widthMultiplier: tag.value, children: (0, jsx_runtime_1.jsx)(SkillLevelText, { widthMultiplier: tag.value, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: `profile.resume.skill.skill_level_${Object.values(types_1.SkillTagSkillLevel)[tag.value - 1]}` }) }) })] }) }, tag.id))) }) })), !areTagsRated && ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(OfferDetails_style_1.TagsWrapper, { children: tags.map(tag => ((0, jsx_runtime_1.jsx)(OfferDetails_style_1.TagWrapper, { children: tag.name }, tag.id))) }) }))] }));
};
exports.OfferDetailsSkillTag = OfferDetailsSkillTag;
